import { useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { SBack, SLowcodeList } from 'shj-components'
import { findChannelLogPage } from '@/services/channelManagement'
import config from './config.js'

export default function FlowChannelLog() {
  const { id } = useParams()
  const listRef = useRef<any>()

  useEffect(() => {
    listRef?.current?.reload()
  }, [id])

  const fetchList = (values: any) => {
    const { current, pageSize, query } = values
    return new Promise((resolve, reject) => {
      try {
        findChannelLogPage({
          params: {
            pageId: current,
            pageSize,
          },
          data: {
            channelId: id,
            queryOrg: true,
            queryCategoryName: true,
            queryTypeName: true,
            ...query,
          },
        }).then(data => {
          resolve(data)
        })
      } catch (e) {
        reject({ success: false })
      }
    })
  }

  const extension = {
    request: { fetchList },
    customRender: {
      orgListRender(orgList: any[]) {
        return orgList.length <= 0 ? '' : orgList.map(item => item.namePath).join(', ')
      },
    },
  }

  return (
    <SBack title={`修改记录`} level={2}>
      <div style={{ width: '100%', height: '100%', backgroundColor: 'white', padding: '15px' }}>
        <SLowcodeList config={config} ref={listRef} {...extension} />
      </div>
    </SBack>
  )
}
